<template>
    <div id="challengeQuestion" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="page == 'question' && question != null" class="questionPage container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto d-flex flex-column">
                    <div class="header justify-content-center mb-3">
                        <progress-bar type="circle" ref="circle" :options="progressOptions" class="timer animate__animated animate__zoomIn animate__faster"></progress-bar>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>
                    <div v-if="user.swappers > 0" class="swapper" :class="swapperUsed ? 'used' : ''">
                        <a @click.prevent="useSwapper();btnSfx();" href="#">
                            <img v-if="!swapperUsed" src="/images/challenges/dandelion.png"/>
                            <img v-else src="/images/challenges/dandelion-used.png"/>
                            <span v-if="!swapperUsed">{{ $t('challenge.question_use_dandelion') }}</span>
                        </a>
                        <div class="swapperFly"></div>
                    </div>

                    <div v-if="question.question.imageUrl != undefined" class="questionWithImage mb-3 w-100">
                        <div class="w-100 vh-20 mb-3 d-flex justify-content-center align-items-center">
                            <img :src="question.question.imageUrl" class="m-auto" @load="setImageLoaded"/>
                        </div>
                        <h5 class="d-flex align-items-center mb-0">{{ question.question.text }}</h5>
                    </div>
                    <h3 v-else class="d-flex align-items-center vh-30">{{ question.question.text }}</h3>

                    <ul v-if="question.question.imageUrl == undefined || imageLoaded" class="answers">
                        <li @click="selectAnswer(a);btnSfx();" v-for="a in question.question.answers" :key="a.id" :class="selectedId == a.id ? 'selected '+selectedClass : ''">
                            {{ a.text }}
                            <i class="fas fa-check-circle"></i><i class="fas fa-times-circle"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div v-else-if="page == 'results'" class="scorePage container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto d-flex flex-column">
                    <div class="header justify-content-center mb-3">
                        <h3 v-if="status == 'win'" class="m-auto text-success">{{ $t('challenge.results_win_title') }}</h3>
                        <h3 v-else-if="status == 'lose'" class="m-auto text-danger">{{ $t('challenge.results_lose_title') }}</h3>
                        <h3 v-else-if="status == 'tie'" class="m-auto text-primary">{{ $t('challenge.results_tie_title') }}</h3>
                        <h3>&nbsp;</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <p class="resultsQuestionText"><span class="text-primary">{{ $t('challenge.results_question') }}</span> {{ results != null ? results.question.text : question.question.text }}</p>

                    <div v-if="status == 'panding'" class="d-flex flex-column justify-content-center h-100">
                        <div class="row pt-2 pb-2">
                            <div class="col-5 text-center">
                                <img :src="user.avatarUrl != undefined ? user.avatarUrl : '/images/male-default.png'" class="profileImage vh-15" />
                                <h4>{{ user.username }}</h4>
                            </div>
                            <div class="col-2 d-flex flex-column align-items-center justify-content-end text-primary">
                                <div>VS</div>
                                <img class="pt-3 mb-5" src="/images/challenges/dots-only.png"/>
                            </div>
                            <div class="col-5 text-center">
                                <img src="/images/challenges/user-wait.png" class="vh-15" />
                            </div>
                        </div>
                        <h4 class="p-4 text-center text-primary">{{ $t('challenge.results_wait_title') }}</h4>
                        <h4 class="text-center">{{ $t('challenge.type_score_title') }}</h4>
                        <div :class="results != null && ((isMeChallenger() && results.challengerAnswerCorrect) || (!isMeChallenger() && results.challengeeAnswerCorrect)) ? 'pandingScore text-success' : 'pandingScore text-danger'">
                            <h1 v-if="results != null"><b>{{ moment.utc(isMeChallenger() ? results.challengerAnswerTime : results.challengeeAnswerTime).format('s.SS') }}s</b></h1>
                        </div>
                        <div class="text-center mb-5 mt-auto">
                            <b-button @click="hide();btnSfx();" type="button" size="lg" variant="primary">{{ $t('base.btn_ok') }}</b-button>
                        </div>
                    </div>
                    <div v-else class="d-flex flex-column justify-content-center h-100">

                        <div :class="'d-flex mt-2 mb-4 text-center flex-fill score '+status">
                            <div class="me">
                                <img :src="user.avatarUrl != undefined ? user.avatarUrl : '/images/male-default.png'" class="profileImage" />
                                <h4 class="mb-4">{{ user.username }}</h4>
                                <div v-if="(isMeChallenger() && results.challengerAnswerCorrect) || (!isMeChallenger() && results.challengeeAnswerCorrect)" class="text-success">
                                    <h1><i class="fas fa-check-circle"></i></h1>
                                    <h4><b>{{ moment.utc(isMeChallenger() ? results.challengerAnswerTime : results.challengeeAnswerTime).format('s.SS') }}s</b></h4>
                                </div>
                                <div v-else><h1 class="text-danger"><i class="fas fa-times-circle"></i></h1></div>
                                <h5>{{ isMeChallenger() ? results.challengerBalance.abbr(true) : results.challengeeBalance.abbr(true) }} <img src="/images/token.png"/></h5>
                            </div>
                            <div class="opponent">
                                <img :src="opponent.avatarUrl != undefined ? opponent.avatarUrl : '/images/male-default.png'" class="profileImage" />
                                <h4 class="mb-4">{{ opponent.username }}</h4>
                                <div v-if="(!isMeChallenger() && results.challengerAnswerCorrect) || (isMeChallenger() && results.challengeeAnswerCorrect)" class="text-success">
                                    <h1><i class="fas fa-check-circle"></i></h1>
                                    <h4><b>{{ moment.utc(!isMeChallenger() ? results.challengerAnswerTime : results.challengeeAnswerTime).format('s.SS') }}s</b></h4>
                                </div>
                                <div v-else><h1 class="text-danger"><i class="fas fa-times-circle"></i></h1></div>
                                <h5>{{ !isMeChallenger() ? results.challengerBalance.abbr(true) : results.challengeeBalance.abbr(true) }} <img src="/images/token.png"/></h5>
                            </div>
                        </div>

                        <div v-if="status == 'win'" class="award p-3 mb-5">
                            <p class="text-primary">{{ $t('challenge.results_win_subtitle') }}</p>
                            <h1><b>{{ isMeChallenger() ? results.challengerBalance.abbr(true) : results.challengeeBalance.abbr(true) }}</b> <img src="/images/token.png"/></h1>
                        </div>

                        <div class="text-center mb-5 mt-auto">
                            <b-button @click="hide();btnSfx();" type="button" size="lg" variant="primary">{{ $t('base.btn_ok') }}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../api'
import confetti from '../confettiHelpers'

const ChallengeQuestion = Vue.component('challenge-question', {
    data() {
        return {
            open: false,
            question: null,
            page: "question",
            lock: false,
            imageLoaded: false,

            selectedId: null,
            selectedClass: "",
            swapperUsed: false,
            
            status: "panding",
            opponent: null,
            results: null,

            progressOptions: {
                color: '#ff8500',
                trailColor: '#abccee',
                strokeWidth: 14,
                trailWidth: 14,
                from: { color: '#ff4e36' },
                to: { color: '#ff8500' },
                step: function(state, circle, attachment) {
                    circle.path.setAttribute('stroke', state.color);
                }
            }
        }
    },

    stopwatch: 0,
    timer: null,
    offset: null,

    computed: {
        user() {
            return this.$store.state.auth.user;
        }
    },

    methods:{

        setImageLoaded(){
            const $this = this;
            this.imageLoaded = true;
            setTimeout(function(){  $this.setTimer(); }, 30);
        },

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show(question, swapper) {
            const $this = this;
            this.question = question;
            this.results = null;
            this.selectedId = null;
            this.selectedClass = "";
            this.page = 'question';
            this.open = true;
            this.status = 'panding';
            this.imageLoaded = false;
            
            if(swapper ==  undefined) 
                this.swapperUsed = false;

            this.$emit("reloadTypes");

            if(this.question.question.imageUrl == undefined)
                setTimeout(function(){  $this.setTimer(); }, 30);
        },

        hide() {
            this.open = false;
            this.data = null;

            if(this.timer != null){ 
                clearInterval(this.timer);
                this.timer = null;
            }
            
            document.getElementById('loader').classList.remove("show");
        },

        selectAnswer(answer){
            if(this.selectedId != null) return;

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            this.selectedId = answer.id;

            if(this.timer != null){ 
                clearInterval(this.timer);
                this.timer = null;
            }

            let dt  = moment.duration($this.question.question.timeout).valueOf();
            
            $this.$refs.circle.set((dt - $this.stopwatch) / dt);
            $this.$refs.circle.setText(moment.utc($this.stopwatch).format('s.SS'));
            
            api.answerToChallengeQuestion(this.question.id, this.selectedId, $this.stopwatch)
                .then(function (response) {
                    let data = response.data;
                    // reload types
                    $this.$emit("reloadTypes");
                    // is answer correct ....
                    $this.selectedClass = ((data.challenger.id == $this.user.id && data.challengerAnswerCorrect) || (data.challengee != undefined && data.challengee.id == $this.user.id && data.challengeeAnswerCorrect)) ? "correct" : "wrong";
                    // wait to see
                    setTimeout(function(){  $this.showResults(data); }, 1500);
                })
                .catch(function (error) {
                    $this.selectedId = null;
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        useSwapper(){
            if(this.swapperUsed || this.selectedId != null || this.user.swappers == 0) return;

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            if(this.timer != null){ 
                clearInterval(this.timer);
                this.timer = null;
            }
            
            this.selectedId = 0;
            let dt  = moment.duration($this.question.question.timeout).valueOf();
            $this.$refs.circle.set((dt - $this.stopwatch) / dt);
            $this.$refs.circle.setText(moment.utc($this.stopwatch).format('s.SS'));
            
            api.replaceChallengeQuestion(this.question.id)
                .then(function (response) {
                    $this.swapperUsed = true;
                    confetti.dandelion();
                    document.querySelector(".questionPage").classList.add("swappAnimation");
                    setTimeout(function(){  
                        $this.show(response.data, true);  
                        document.querySelector(".questionPage").classList.remove("swappAnimation");
                    }, 1500);
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    $this.selectedId = null;
                    loader.classList.remove("show");
                });
        },

        showResults(data){
            this.open = true;
            this.results = data;
            this.page = "results";

            if(data.status == 'CHALLENGEE_PENDING'
                || data.status == 'CHALLENGER_PENDING'
                || data.status == 'PAIRING_PENDING')
                this.status = "panding";
            else if(data.status == 'TIE')
                this.status = "tie";
            else if((data.challenger.id == this.user.id && data.status == 'CHALLENGER_WON') || (data.challengee.id == this.user.id && data.status == 'CHALLENGEE_WON'))
                this.status = "win";
            else 
                this.status = "lose";

            this.opponent = data.challenger != undefined && data.challenger.id == this.user.id ? data.challengee : data.challenger;
            
            // reload user data
            this.$store.dispatch('auth/getMe');
        },

        setTimer(){
            const $this = this;
            if(this.timer != null){ 
                clearInterval(this.timer);
                this.timer = null;
            }

            this.offset = moment.utc();
            this.stopwatch = 0;
            this.$refs.circle.setText(0);
            this.$refs.circle.set(1);

            let sec = 0;
            let dt  = moment.duration($this.question.question.timeout).valueOf();

            this.timer = setInterval(() => { 
                
                let now = moment.utc(),
                    d   = now - $this.offset;

                $this.offset = now;
                $this.stopwatch += d;

                $this.$refs.circle.set((dt - $this.stopwatch) / dt);
                $this.$refs.circle.setText(moment.utc($this.stopwatch).format('s.SS'));

                if (dt - $this.stopwatch < 5000 && $this.selectedId == null && sec != moment.utc($this.stopwatch).seconds())
                    $this.$store.dispatch('sound/sfx','Timer');

                sec = moment.utc($this.stopwatch).seconds();

                if($this.stopwatch > dt){
                    clearInterval($this.timer);
                    $this.timer = null;
                    $this.page = "results";
                }

            }, 10);
        },

        isMeChallenger(){
            return (this.results != null && this.results.challenger != undefined && this.results.challenger.id == this.user.id);
        },

    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    }
})

export default ChallengeQuestion
</script>